<template>
<div v-on-clickaway="away">
    <input v-model="handler" class="form-control w-auto " type="text" :placeholder="placeholder" @click="showResults" @input="showResults" @keydown="handleKeyDown">
    <div v-if="showingResults" class="results">
        <div v-for="(result,index) in results" @click="showConfig(result)" :class="{hover:index==hoverIndex}" @mouseEnter="hoverIndex = index">
            {{ result.family }}
        </div>
    </div>
    <div v-if="showingConfig" class="config">
        <h3 :style="{fontFamily:selected.family}">{{ selected.family }}</h3>
        <div class="columns">
            <div class="variant" v-for="variant in selected.variants">
                <label class="checkbox">
                    <input type="checkbox" v-model="variants" :value="variant"> {{variant}}
                </label>
            </div>
        </div>

        <button class="btn btn-primary mr-2" @click.prevent="choose"> {{_lang('Confirm')}}</button>
        <button class="btn btn-light" @click.prevent="back"> {{_lang('Cancel')}}</button>

    </div>

</div>
</template>

<style scoped>

.results {
    position: absolute;
    background: #fff;
    box-shadow: 1px 1px 4px rgba(0,0,0,.5);
    min-width: 280px;
    z-index: 3;
}
.results div {
    padding: 5px 15px;
    cursor: pointer;
}
.results div:hover, .results div.hover {
    background:rgba(0,0,0,.1);
}
.config {
    position: absolute;
    background: #fff;
    box-shadow: 1px 1px 4px rgba(0,0,0,.5);
    padding:15px;
    z-index: 3;
}
.config h3 { }
.columns  {
    display: flex;
    flex-wrap: wrap;
    max-width:280px;
}
.config .variant {
    flex-basis:50%;
}

</style>
<script>
import axios from 'axios';
import WebFont from 'webfontloader';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'project-form',
  mixins: [ clickaway ],
  props:['value','placeholder'],
  data(){
      return {
          handler:'',
          fonts:[],
          selected:'',
          hoverIndex:null,

          variants:[],
          showingResults:false,
          showingConfig:false,

      }
  },
  computed:{
      results(){
          var term = this.handler.toLowerCase().trim();
          if(!term) return this.fonts.slice(0,10);

          return this.fonts.filter(item=>
            item.family.toLowerCase().includes(term)
          ).slice(0,10);
      }
  },
  methods:{
      handleKeyDown(e){
        if(e.keyCode==40){
            e.preventDefault();
            if(this.hoverIndex==null){
                this.hoverIndex = 0;
                return;
            }
            this.hoverIndex++;

        }
        if(e.keyCode==38){
            e.preventDefault();
            this.hoverIndex--;
        }
        if(e.keyCode==13){
            e.preventDefault();
            if(this.hoverIndex!==null)
            this.showConfig(this.results[this.hoverIndex]);
        }
        if(e.keyCode==27){
            e.preventDefault();
            this.showingConfig=false;
            this.showingResults=false;
        }
      },
      away(){
            this.showingConfig=false;
            this.showingResults=false;
      },
      showResults(){
          this.showingConfig = false;
          this.showingResults = true;
      },
      showConfig(font){
        WebFont.load({
            google: { families: [font.family] }
        });
          this.showingResults = false;
          this.selected = font;
          this.variants = ['regular'];
          this.showingConfig = true;
      },
      back(){
          this.showingConfig = false;
          this.showingResults = true;
      },
      choose(){
          var font = {
              family:this.selected.family,
              variants:this.variants,
          }
          console.log('choose',font);
          this.showingConfig = false;
          this.$emit('input',font);
          this.$emit('add',font);
      },

  },
  mounted(){
        axios.get('https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=AIzaSyArs8zOO534PoO39hmZUNfgNzU1VRZl2tE').then(res=>{
              this.fonts = res.data.items;
        });

        // document.addEventListener('keydown',this.handleEsc);

  },
  destroyed(){
    //   console.log('destroyed');
    //   document.removeEventListener('keydown',this.handleEsc);
  }
}

</script>

